import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useRequestFormatReducer = () => useSelector((state: ApplicationState) => state.requestFormat);
